<template>
  <section class="newsletter-signup">
    <h2 class="newsletter-title">Stay Ahead with the Banana's ARM News</h2>
    <p class="newsletter-description">
      Sign up to receive updates, new product releases, and exclusive promotions.
    </p>
    <div class="signup-form">
      <input type="email" placeholder="Enter your email" class="email-input" />
      <button class="subscribe-button">Subscribe</button>
    </div>
  </section>
</template>

<script>
export default {
  name: "NewsletterSignUp",
};
</script>

<style scoped>
.newsletter-signup {
  background-color: #f7f7f7;
  padding: 40px 20px;
  text-align: center;
  border-radius: 8px;
  max-width: 500px;
  margin: 0 auto;
}

.newsletter-title {
  font-size: 1.8em;
  margin-bottom: 10px;
  color: #333;
}

.newsletter-description {
  font-size: 1em;
  color: #666;
  margin-bottom: 20px;
}

.signup-form {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.email-input {
  padding: 10px;
  font-size: 1em;
  border: 1px solid #ccc;
  border-radius: 4px;
  flex: 1;
}

.subscribe-button {
  background-color: crimson;
  color: white;
  border: none;
  padding: 10px 20px;
  font-size: 1em;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
}

.subscribe-button:hover {
  background-color: darkred;
}
</style>
